/* LES AVIS EN LIGNE : flèches, et retrait de la section si Junip n'a rien rendu.
 *
 * ⛔ ON N'ATTEND PAS UN ÉVÉNEMENT DE L'APP. Junip ne publie aucun signal de fin de rendu : on
 * observe donc le conteneur. Un `setTimeout` unique aurait mesuré au mauvais moment, et une
 * section vide serait restée en place, ou une section pleine aurait été retirée.
 *
 * ⚠️ UNE SECTION QUI N'A RIEN À DIRE DOIT DISPARAÎTRE, pas rester en bande vide : c'est la
 * même règle que pour les onglets du bloc au-dessus.
 */
(function () {
  'use strict';
  /* ⛔⛔ CE SCRIPT NE SERVAIT QU'A UN SEUL BLOC, ET LA PAGE B2B EN A UN AUTRE. Il portait
     `getElementById('avisline')` : la page professionnelle rend ses avis dans `#b2b-avis`, avec
     le meme marquage Junip, et n'a donc JAMAIS recu les traductions, alors qu'elles existent et
     servent sur les fiches produit. Releve le 21/08/2026 en cherchant pourquoi onze avis
     s'affichaient en francais sur /nl/ et /de/ ; j'avais d'abord conclu, a tort, que c'etait
     normal parce qu'ils sont ecrits par des clients francais. Adrien : « les avis ont deja ete
     traduits par toi, ce sont les memes que sur les pages produit ».
     ⚠️ C'EST LA MEME LECON QUE LA SERRURE POSEE AILLEURS : un garde ne couvre que ce qu'il vise,
     et le meme besoin ecrit ailleurs passe sans erreur.
     ⚠️ ET LE RESTE DU SCRIPT SUPPORTE DEJA L'ABSENCE DE RAIL : les fleches, l'egalisation et le
     compte sortent tous quand leur element manque. Le bloc B2B n'a ni rail ni fleches, il n'a
     que la fenetre qui defile, et c'est tout ce dont la traduction a besoin. */
  var sec = document.getElementById('avisline') || document.getElementById('b2b-avis');
  if (!sec || sec.dataset.avislineArme === '1') return;
  sec.dataset.avislineArme = '1';

  var enLignes = sec.hasAttribute('data-avis-liste');
  var selecteurAvis = '.junip-review-grid-item-container, .junip-review-list-item-container';
  var rail = sec.querySelector('[data-avisline-rail]');
  var g = sec.querySelector('[data-avisline-prec]');
  var d = sec.querySelector('[data-avisline-suiv]');

  function liste() { return sec.querySelector('.junip-reviews-container'); }

  /* Les photos passent avant les avis sans photo, dans le rail ET le tiroir.
     Le tri porte sur les vrais noeuds : le tiroir est en display:block. Les avatars
     Junip ne sont pas des photos client. L'ordre reste stable dans chaque groupe. */
  function photosEnPremier() {
    if (enLignes) return;
    var l = liste();
    if (!l) return;
    var cartes = [].slice.call(l.children).filter(function (c) {
      return c.classList.contains('junip-review-grid-item-container');
    });
    var triees = cartes.filter(function (c) { return c.querySelector('.junip-review-image'); })
      .concat(cartes.filter(function (c) { return !c.querySelector('.junip-review-image'); }));
    for (var i = 0; i < triees.length; i += 1) {
      var actuelle = l.querySelectorAll('.junip-review-grid-item-container')[i];
      if (actuelle !== triees[i]) l.insertBefore(triees[i], actuelle);
    }
  }

  function majFleches() {
    var l = liste();
    if (!l || !g || !d) return;
    g.disabled = l.scrollLeft <= 4;
    d.disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 4;
  }

  function pas(l) {
    var c = l.firstElementChild;
    var w = c ? c.getBoundingClientRect().width + 16 : 320;
    return Math.max(w, l.clientWidth - w);
  }

  var branche = false;
  function brancher() {
    if (enLignes) return;
    var l = liste();
    if (!l || branche) return;
    branche = true;
    if (g) g.addEventListener('click', function () { l.scrollBy({ left: -pas(l), behavior: 'smooth' }); });
    if (d) d.addEventListener('click', function () { l.scrollBy({ left: pas(l), behavior: 'smooth' }); });
    l.addEventListener('scroll', majFleches, { passive: true });
    window.addEventListener('resize', majFleches, { passive: true });
    sec.classList.add('is-prete');
    majFleches();
  }

  /* ⛔⛔ LES CARTES A LA MEME HAUTEUR, ET IL A FALLU LE FAIRE EN JAVASCRIPT (Adrien, 428-2 :
     « il reste un enorme vide sous bloc avis sur mobile. Les cartes doivent etre a la meme
     hauteur sur mobile »).
     ⛔ POURQUOI LE CSS N'A PAS SUFFI, MESURE PLUTOT QUE SUPPOSE. La piste est un conteneur flex
     d'une seule rangee ; `align-items:stretch` et `height:auto` sont bien CALCULES sur les cartes
     (releve du 19/08/2026 a 390 px : `align-self: stretch`, `height: 277.688px`), et pourtant
     rien ne s'etire. Quatre corrections ont ete essayees sur la page servie et n'ont eu AUCUN
     effet mesurable sur les hauteurs : `min-height:100%`, `height:100%`, `align-self:auto`, et
     meme le conteneur passe en `display:grid` avec `grid-auto-rows:1fr` (verifie applique :
     `display: grid`, `grid-auto-rows: 1fr`, cartes enfants DIRECTS). Les cartes restaient a
     254 / 299 / 591. Mes regles atteignent bien ces cartes (prouve par un contour pose expres).
     La cause exacte du refus d'etirement n'est pas trouvee.
     ⛔ ON MESURE DONC, ET ON POSE. Une hauteur minimale egale a la plus grande carte : c'est le
     seul chemin dont le resultat se verifie (releve apres : 491 px sur les douze cartes, ecart
     nul). Sur ordinateur les cartes sont deja egales, la pose n'y change donc rien.
     ⚠️ ON EFFACE AVANT DE MESURER. Sans cela, la deuxieme passe mesurerait la hauteur qu'on
     vient d'imposer et le bloc grandirait a chaque tour, sans jamais redescendre.
     ⚠️ ET L'OBSERVATEUR NE DOIT PAS SE MORDRE LA QUEUE : effacer puis poser change la taille,
     ce qui reveille le ResizeObserver. Le drapeau `enCours` coupe la boucle, et le travail est
     remis a la frame suivante pour que la mesure se fasse sur une mise en page stable. */
  var enCours = false;
  function egaliser() {
    if (enLignes) return;
    var l = liste();
    if (!l || enCours) return;
    var cartes = [].slice.call(l.querySelectorAll('.junip-review-grid-item-container'));
    if (!cartes.length) return;
    /* ⛔⛔ PAS D'EGALISATION DANS LE TIROIR (Adrien, 30/08/2026 : « les cartes sont trop hautes
       dans le drawer avis mobile et desktop, elles doivent faire la hauteur du contenu »).
       Egaliser a un sens sur la PISTE de la page : les cartes y sont cote a cote, et une carte
       plus courte que sa voisine laisse un trou. Dans le tiroir elles sont EMPILEES : la plus
       haute impose alors sa hauteur a toutes les autres, et un avis de deux mots occupe l'ecran
       entier. Mesure du jour : min-height 334 px sur telephone, 434 sur ordinateur, pour
       « Tres satisfaite / Tres satisfaite ».
       ⚠️ ON EFFACE AU LIEU DE SORTIR EN SILENCE : c'est le MEME noeud qui voyage de la page au
       tiroir, il arrive donc avec les hauteurs posees pour la piste. Sortir sans les retirer les
       laisserait telles quelles, et le defaut serait identique. Au retour sur la page, cette
       meme fonction repasse et les repose.
       ⚠️ LE TEST PORTE SUR LA LISTE, PAS SUR UN DRAPEAU GLOBAL : le tiroir est fabrique par
       `etoiles-produit.js`, qui n'expose rien, et deux fichiers qui se racontent leur etat
       finissent par se contredire. La position dans le document EST l'etat. */
    if (l.closest && l.closest('.avis-tiroir')) {
      for (var j = 0; j < cartes.length; j += 1) cartes[j].style.minHeight = '';
      return;
    }
    enCours = true;
    requestAnimationFrame(function () {
      /* ⚠️ AVANT LA MESURE : le bouton « lire la suite » occupe une ligne, et une hauteur
         calculee sans lui serait fausse d'autant sur les cartes qui le portent. */
      try { majLire(); } catch (eL) { /* une carte de moins n'empeche pas d'egaliser */ }
      var i, h = 0;
      for (i = 0; i < cartes.length; i += 1) cartes[i].style.minHeight = '';
      for (i = 0; i < cartes.length; i += 1) {
        h = Math.max(h, cartes[i].getBoundingClientRect().height);
      }
      if (h > 0) {
        var px = Math.ceil(h) + 'px';
        for (i = 0; i < cartes.length; i += 1) cartes[i].style.minHeight = px;
      }
      enCours = false;
    });
  }
  /* ⛔ QUELQUES AVIS LONGS RENDAIENT TOUTES LES CARTES TROP HAUTES (Adrien, 24/08/2026 : « il
     faut limiter la hauteur des cartes avis sur mobile, elles sont trop hautes pour 90 % des avis
     a cause de quelques avis plus longs, dont on peut montrer le debut du texte. Si l'internaute
     veut voir la suite il n'a qu'a cliquer sur la carte »).
     La piste est horizontale et toutes les cartes prennent la hauteur de la plus grande : mesure
     du jour sur une fiche, 13 cartes a 333 px sur telephone pour UN avis de 175 signes, quand
     les autres en font dix. Le corps est donc borne a quatre lignes par la feuille, et une carte
     dont le texte deborde s'ouvre AU CLIC, n'importe ou sur elle.
     ⚠️ ON MESURE LE DEBORDEMENT, ON NE COMPTE PAS LES SIGNES. Un nombre de caracteres ne dit
     rien du nombre de LIGNES : la largeur de carte change avec l'ecran, et la meme phrase tient
     sur trois lignes ici et sur cinq la. `scrollHeight > clientHeight` est la seule mesure qui
     reponde a la question posee.
     ⚠️ LA CARTE ENTIERE EST LA CIBLE, ET LE BOUTON RESTE. Toute la carte repond au doigt, comme
     demande ; le `<button>` reste dans le balisage parce que c'est LUI que le clavier atteint et
     que le lecteur d'ecran annonce. Poser `role="button"` sur la carte aurait enferme du texte et
     d'autres commandes dans un bouton, ce qu'aucun lecteur d'ecran ne restitue correctement.
     ⚠️ ET UN CLIC SUR UNE COMMANDE INTERNE N'OUVRE RIEN : le bouton de traduction de Junip et
     celui de la langue d'origine vivent dans la carte, et les avaler ferait deux gestes pour un.
     ⚠️ IDEMPOTENTE, ET DANS LES DEUX SENS. Rejouee a chaque mise en page : le repere s'ajoute
     quand le texte deborde, et se retire quand il ne deborde plus (ecran elargi, traduction plus
     courte). Sans le retrait, il resterait a promettre une suite qui n'existe pas. Une carte deja
     ouverte n'est jamais refermee : ce serait defaire le clic du lecteur. */
  function ouvrir(carte) {
    if (!carte || carte.getAttribute('data-avis-ouvert') === '1') return;
    carte.setAttribute('data-avis-ouvert', '1');
    var b = carte.querySelector('.avisline__lire');
    if (b && b.parentNode && b.parentNode.parentNode) {
      b.parentNode.parentNode.removeChild(b.parentNode);
    }
    egaliser();
  }

  function majLire() {
    var l = liste();
    if (!l) return;
    var mot = sec.dataset.lire || '';
    if (!mot) return;
    var cartes = [].slice.call(l.querySelectorAll('.junip-review-grid-item-container'));
    cartes.forEach(function (carte) {
      var corps = carte.querySelector('.junip-review-body');
      if (!corps) return;
      if (carte.getAttribute('data-avis-ouvert') === '1') return;
      var deja = carte.querySelector('.avisline__lire');
      var deborde = corps.scrollHeight > corps.clientHeight + 1;
      if (!deborde) {
        if (deja && deja.parentNode && deja.parentNode.parentNode) {
          deja.parentNode.parentNode.removeChild(deja.parentNode);
        }
        carte.removeAttribute('data-avis-long');
        return;
      }
      carte.setAttribute('data-avis-long', '1');
      if (deja) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'avisline__orig avisline__lire';
      b.textContent = mot;
      var boite = document.createElement('div');
      boite.className = 'avisline__origline';
      boite.appendChild(b);
      (corps.parentNode || carte).appendChild(boite);
    });
  }

  /* Un seul ecouteur, sur la piste : les cartes sont redessinees par Junip a chaque rendu, et
     un ecouteur pose sur chacune serait a reposer a chaque fois. */
  sec.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var carte = t.closest('.junip-review-grid-item-container');
    if (!carte || carte.getAttribute('data-avis-long') !== '1') return;
    /* Le bouton de lecture, lui, DOIT ouvrir : c'est le meme geste. Les autres commandes non. */
    if (t.closest('a, button') && !t.closest('.avisline__lire')) return;
    ouvrir(carte);
  });

  /* La largeur change (rotation, barre d'adresse qui se replie) : les textes se recomposent et
     la plus grande carte n'est plus la meme. */
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () { egaliser(); });
    ro.observe(document.documentElement);
  } else {
    window.addEventListener('resize', egaliser, { passive: true });
  }
  /* Les images arrivent apres le texte et poussent leur carte : sans ce second passage, la
     hauteur posee serait celle d'avant les photos. */
  window.addEventListener('load', egaliser);

  /* ⛔ NE PAS DECLENCHER LE BOUTON DE TRADUCTION DE JUNIP. ESSAYE LE 19/08/2026, RETIRE.
   *
   * L'idee etait bonne et le mecanisme repond : un clic sur `.junip-translate-button` traduit
   * le corps et Junip pose lui-meme « Origineel tonen (vertaald door AI) ». Deux murs l'ont
   * condamnee, tous deux mesures :
   *
   * 1. L'API de traduction n'est pas dans notre abonnement Junip. Elle repond aujourd'hui,
   *    mais nous ne payons pas pour elle : batir l'affichage des avis dessus, c'est le batir
   *    sur ce qu'ils peuvent nous couper sans preavis.
   * 2. Elle est severement limitee. Cliquer les douze boutons d'une page a produit 288 appels,
   *    dont 278 refuses en 429 : Junip reessaie en boucle de son cote, donc depasser le quota
   *    ne rate pas seulement la traduction, cela matraque leur API depuis le navigateur du
   *    client.
   *
   * La traduction des avis passe desormais par GPT sur serveur, en amont, et le texte traduit est
   * injecte dans la page. Cela couvre AUSSI les cinq langues du site que Junip ne connait pas
   * (pl, cs, el, hr, hu) et le desktop, ou Junip ne met aucun bouton dans la carte.
   *
   * Ne pas remettre un clic automatique ici : le banc tests/avis-traduits.test.js le refuse.
   */

  /* ── LES AVIS DANS LA LANGUE DU VISITEUR ────────────────────────────────────────────
   *
   * Junip rend l'avis dans la langue ou le client l'a ecrit. GPT sur serveur le traduit en amont dans
   * les treize langues, le Studio le sert, et on le pose ici. Adrien, 19/08/2026 : « d'abord la
   * traduction avec option de voir l'original ».
   *
   * ⛔ LA CLE EST LE TEXTE, PAS UN IDENTIFIANT. Le DOM d'une carte d'avis n'en porte aucun :
   * verifie sur la carte entiere le 19/08/2026, il n'y a ni data-id ni rien qui s'en approche.
   * Le seul point commun entre une carte affichee et une ligne de notre base est le texte
   * d'origine, compare a la casse et a la ponctuation pres.
   *
   * ⛔ ON N'ECRIT QUE DU TEXTE, JAMAIS DU HTML. Un avis est la parole d'un client, il passe par
   * une chaine de traduction : `textContent` ferme la question de ce qui pourrait s'y glisser.
   *
   * ⚠️ UNE TRADUCTION ABSENTE N'EST PAS UNE PANNE. La carte reste dans sa langue d'origine,
   * exactement comme avant. Le bloc ne doit jamais dependre de cette route pour s'afficher.
   */
  var BASE_STUDIO = 'https://runway.dcomdtf.app';

  function texteNu(x) {
    return String(x || '').toLowerCase().replace(/[\s\u00a0]+/g, ' ')
      .replace(/[.,;:!?'’"«»()\-]/g, '').trim();
  }

  var etatsTraductions = new WeakMap();
  function libelle(nom) {
    var texte = (nom === 'original' ? sec.dataset.original : sec.dataset.traduction) || '';
    return window.murDeshtml ? window.murDeshtml(texte) : texte;
  }

  function poserBascule(carte, etat, corpsEl) {
    var b = carte.querySelector('[data-avis-bascule]');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'avisline__orig';
      b.setAttribute('data-avis-bascule', '');
      b.addEventListener('click', function () {
        var courant = etatsTraductions.get(carte);
        courant.originalAffiche = !courant.originalAffiche;
        poserTraductions(indexTraductions);
      });
      var boite = document.createElement('div');
      boite.className = 'avisline__origline';
      boite.appendChild(b);
      /* Hors du corps : Junip recalcule et remplace son span au redimensionnement. */
      var corps = carte.querySelector('.junip-review-body');
      corps.parentNode.insertBefore(boite, corps.nextSibling);
    }
    var mot = libelle(etat.originalAffiche ? 'traduction' : 'original');
    if (b.textContent !== mot) b.textContent = mot;
  }

  /* ⛔ JUNIP TRONQUE LE CORPS AFFICHE QUAND IL EST LONG. Mesure du 19/08/2026 : un avis
   * restait entierement en francais parce que le texte de sa carte n'etait plus egal au texte
   * d'origine. On compare donc aussi par PREFIXE : trente signes de debut d'avis ne se repetent
   * pas d'un client a l'autre, et si cela arrivait, les deux avis diraient la meme chose.
   *
   * ⚠️ ON CHERCHE D'ABORD L'EGALITE. Un prefixe pris en premier apparierait un avis court avec
   * un avis long qui commence pareil, et le client lirait la phrase de quelqu'un d'autre. */
  var PREFIXE = 30;
  function trouver(index, texte) {
    var cle = texteNu(texte);
    if (index[cle]) return index[cle];
    if (cle.length < PREFIXE) return null;
    var debut = cle.slice(0, PREFIXE);
    var trouves = [];
    for (var k in index) {
      if (Object.prototype.hasOwnProperty.call(index, k)
        && (k.slice(0, PREFIXE) === debut)) trouves.push(index[k]);
    }
    return trouves.length === 1 ? trouves[0] : null;
  }

  var traductionsPosees = false;
  function poserTraductions(index) {
    var cartes = sec.querySelectorAll(selecteurAvis);
    var n = 0;
    for (var i = 0; i < cartes.length; i += 1) {
      var carte = cartes[i];
      var corpsEl = carte.querySelector('.junip-review-body span') || carte.querySelector('.junip-review-body');
      if (!corpsEl) continue;
      var etat = etatsTraductions.get(carte);
      var t = trouver(index, corpsEl.textContent);
      if (t && (!etat || etat.traduction.o !== t.o)) {
        var titreSource = carte.querySelector('.junip-review-title');
        etat = { traduction: t, titreOriginal: titreSource ? titreSource.textContent : '',
          originalAffiche: false };
        etatsTraductions.set(carte, etat);
      }
      if (!etat || !etat.traduction.c) continue;
      t = etat.traduction;
      var titreEl = carte.querySelector('.junip-review-title');
      var corpsVoulu = etat.originalAffiche ? t.o : t.c;
      var titreVoulu = etat.originalAffiche ? etat.titreOriginal : t.t;
      /* Relire les noeuds et leurs textes, jamais se fier au drapeau seul : Junip
         peut garder la carte et son titre tout en remettant le corps source. */
      if (corpsEl.textContent !== corpsVoulu) { corpsEl.textContent = corpsVoulu; n += 1; }
      if (titreEl && titreVoulu && titreEl.textContent !== titreVoulu) {
        titreEl.textContent = titreVoulu; n += 1;
      }
      if (carte.getAttribute('role') === 'button' && titreVoulu && carte.getAttribute('aria-label') !== titreVoulu) {
        carte.setAttribute('aria-label', titreVoulu);
      }
      carte.dataset.avisTraduit = '1';
      poserBascule(carte, etat, corpsEl);
    }
    if (n) egaliser();
    return n;
  }

  /* ⛔ « N AVIS VERIFIES » SOUS LA NOTE (Adrien, 19/08/2026). Junip n'affiche que la moyenne et
   * les etoiles : son conteneur d'actions, celui qui portait le compte, est masque depuis que
   * sa marge gauche automatique de 328 px cassait le centrage. On repose donc la mention
   * nous-memes, avec le nombre que le Studio calcule sur les avis reels.
   * ⚠️ LE SEUL HTML POSE ICI EST UN DESSIN FIXE, ecrit dans ce fichier : aucune donnee venue
   * du reseau n'y entre. Le compte, lui, passe par textContent comme le reste.
   * ⚠️ RIEN NE S'AFFICHE SANS CHIFFRE. Une mention « avis verifies » sans compte ne prouve rien,
   * et un « 0 avis verifies » sous une note de 4,9 se lit comme une panne. */
  /* ⛔ ET ON GARDE LE CHIFFRE POUR PLUS TARD. Mesure du 19/08/2026 : la ligne ne se posait
   * jamais. Notre reponse reseau arrive AVANT que Junip n'ait rendu son resume : le premier
   * appel ne trouvait rien a quoi s'accrocher, et rien ne le rejouait. Le total est donc
   * memorise, et chaque mutation du bloc retente la pose. */
  /* ⛔ LA MENTION SOUS LES ETOILES (Adrien, 24/08/2026, capture d'un concurrent : « dans bloc
     d'avis page produit, ajoute "Excellent" en gras sous les etoiles »).
     ⚠️ UN VRAI ELEMENT, PAS UN `content:` DE FEUILLE. Un mot pose en CSS n'est ni selectionnable,
     ni lu par la plupart des lecteurs d'ecran, ni traduisible autrement qu'en le recopiant dans
     treize regles. Il vit donc dans la locale et arrive par `data-mention`, exactement comme la
     mention de verification juste en dessous.
     ⚠️ MEME PRUDENCE QUE `poserCompte` : Junip rend son resume APRES nous, et chaque mutation du
     bloc rejoue la pose. Le garde-fou est la presence de l'element, pas un drapeau : un drapeau
     resterait leve si Junip redessinait son resume et effacait le notre. */
  function poserMention() {
    var resume = sec.querySelector('.junip-product-review-summary-container');
    if (!resume || sec.querySelector('.avisline__mention')) return;
    var mot = sec.dataset.mention || '';
    if (!mot) return;
    var p = document.createElement('p');
    p.className = 'avisline__mention';
    p.textContent = mot;
    /* ⛔ SOUS LES ETOILES, DONC DANS LEUR COLONNE, ET PAS SOUS LE BLOC. Le resume porte un
       `::after` qui dessine le filet de separation dans sa marge basse : pose apres le resume,
       le mot tombait SOUS ce filet, du cote de la signature « verifie par Junip » au lieu du
       cote de la note. Ce sont deux choses differentes, et le filet est justement la pour les
       separer. La colonne du resume est en `flex-direction:column; align-items:center` : y
       ajouter le mot le met exactement sous les etoiles, centre, sans une regle de plus.
       ⚠️ REPLI SUR L'ANCIEN PLACEMENT si Junip renomme sa colonne : mieux vaut la mention au
       mauvais etage que pas de mention du tout. */
    var colonne = resume.querySelector('.junip-product-review-summary-flex-wrapper');
    if (colonne) colonne.appendChild(p);
    else resume.parentNode.insertBefore(p, resume.nextSibling);
  }

  var totalAvis = 0;
  function poserCompte(total) {
    if (total) totalAvis = total;
    total = totalAvis;
    if (!total) return;
    var resume = sec.querySelector('.junip-product-review-summary-container');
    if (!resume || sec.querySelector('.avisline__compte')) return;
    var libelle = sec.dataset.verifies || '';
    var p = document.createElement('p');
    p.className = 'avisline__compte';
    /* ⛔ LE LOGO EST CELUI DE JUNIP, fourni par Adrien le 19/08/2026, servi depuis nos assets et
       non depuis leur CDN : une mention de confiance ne doit pas dependre d'un domaine tiers
       pour s'afficher. Le mot « Junip » est DANS le dessin, il n'est plus dans le libelle. */
    var logo = sec.dataset.junip || '';
    /* ⛔ LA MENTION SANS LE NOMBRE (Adrien, 19/08/2026 : « on n'en a pas assez pour le
       moment »). Le compte reste calcule cote Studio, il ne s'affiche plus. */
    p.appendChild(document.createTextNode(libelle));
    if (logo) {
      var im = document.createElement('img');
      im.src = logo;
      im.alt = 'Junip';
      im.className = 'avisline__junip';
      im.setAttribute('loading', 'lazy');
      p.appendChild(im);
    }
    /* ⛔ APRES LE RESUME, ET SURTOUT PAS APRES LA MENTION (Adrien, 24/08/2026 : « "excellent"
       doit etre au dessus du trait, pas en-dessous »).
       Le filet de separation est le `::after` du RESUME, dessine dans sa marge basse. « Excellent »
       vit maintenant DANS le resume, avec la note et les etoiles ; la signature de verification,
       elle, doit rester en dehors, sinon le filet tombe sous les deux et ne separe plus rien.
       Une version precedente inserait ici « apres la mention » : la mention ayant demenage dans
       la colonne du resume, cette regle y faisait entrer la signature avec elle, et le filet
       passait sous tout le bloc. */
    resume.parentNode.insertBefore(p, resume.nextSibling);
    egaliser();
  }

  var indexTraductions = null;
  function chargerTraductions() {
    if (indexTraductions) { poserTraductions(indexTraductions); return; }
    if (traductionsPosees) return;
    var lang = (sec.dataset.langue || '').toLowerCase();
    if (!lang) return;
    traductionsPosees = true;
    /* Revalider a chaque visite : un ancien cache d'une heure masque les traductions
       que la passe automatique vient de terminer. Une requete par page suffit. */
    fetch(BASE_STUDIO + '/avis-traductions?lang=' + encodeURIComponent(lang), { credentials: 'omit', cache: 'no-cache' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        poserCompte(d && d.total);
        var liste = (d && d.avis) || [];
        if (!liste.length) return;
        indexTraductions = {};
        for (var i = 0; i < liste.length; i += 1) {
          indexTraductions[texteNu(liste[i].o)] = liste[i];
        }
        poserTraductions(indexTraductions);
      })
      .catch(function () { /* la carte reste dans sa langue d'origine */ });
  }

  var focusApresAjout = null;
  var ajoutAutomatique = false;
  var dernierChargement = -1;
  var observateurSuite = null;
  var corpsObserve = null;
  var boutonObserve = null;
  var compteObserve = -1;
  sec.addEventListener('click', function (ev) {
    if (!enLignes || !ev.target.closest('.junip-see-more')) return;
    dernierChargement = sec.querySelectorAll(selecteurAvis).length;
    focusApresAjout = !ajoutAutomatique && ev.detail === 0 ? dernierChargement : null;
  });

  function preparerDefilement() {
    if (!enLignes || !window.IntersectionObserver) return;
    var corps = sec.closest('.avis-tiroir[data-ouvert] .avis-tiroir__corps');
    var plus = sec.querySelector('.junip-see-more:not(:disabled)');
    var compte = sec.querySelectorAll(selecteurAvis).length;
    if (corps === corpsObserve && plus === boutonObserve && compte === compteObserve) return;
    if (observateurSuite) observateurSuite.disconnect();
    observateurSuite = null;
    corpsObserve = corps;
    boutonObserve = plus;
    compteObserve = compte;
    if (!corps || !plus || !compte) return;
    observateurSuite = new IntersectionObserver(function (entrees) {
      if (!entrees.some(function (entree) { return entree.isIntersecting; })
          || !corps.closest('.avis-tiroir[data-ouvert]') || !corps.contains(sec)
          || !sec.contains(plus) || plus.disabled) return;
      var nombre = sec.querySelectorAll(selecteurAvis).length;
      if (nombre === dernierChargement) return;
      dernierChargement = nombre;
      ajoutAutomatique = true;
      try { plus.click(); } finally { ajoutAutomatique = false; }
    }, { root: corps, rootMargin: '0px 0px 350px 0px', threshold: 0 });
    observateurSuite.observe(plus);
  }

  function preparerListe() {
    if (!enLignes) return;
    var plus = sec.querySelector('.junip-see-more');
    if (plus && !plus.disabled && sec.dataset.plus && plus.textContent !== sec.dataset.plus) {
      plus.textContent = sec.dataset.plus;
    }
    var titrePhotos = sec.querySelector('.junip-ugc-gallery-title');
    if (titrePhotos) {
      titrePhotos.setAttribute('role', 'heading');
      titrePhotos.setAttribute('aria-level', '2');
    }
    var cartes = sec.querySelectorAll(selecteurAvis);
    if (focusApresAjout !== null && cartes.length > focusApresAjout) {
      var premiere = cartes[focusApresAjout];
      focusApresAjout = null;
      premiere.tabIndex = -1;
      premiere.focus({ preventScroll: true });
    }
    preparerDefilement();
  }

  sec.addEventListener('avis:tiroir', preparerListe);
  var vus = 0;
  var mo = new MutationObserver(function () {
    if (liste()) { preparerListe(); photosEnPremier(); brancher(); majFleches(); chargerTraductions(); poserMention(); poserCompte(0); egaliser(); }
  });
  mo.observe(sec, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'disabled'] });
  preparerListe();

  /* Au bout de douze secondes sans rien, l'app ne répondra pas : on retire la bande. */
  setTimeout(function () {
    if (!liste() || !sec.querySelectorAll(selecteurAvis).length) { mo.disconnect(); sec.remove(); }
    else { preparerListe(); photosEnPremier(); brancher(); majFleches(); chargerTraductions(); poserMention(); poserCompte(0); egaliser(); }
  }, 12000);
})();
